import { db, auth } from '../config/firebase';
import { onValue, ref } from 'firebase/database';

export const testFirebaseConnection = () => {
  // Test database connection
  const testRef = ref(db, '.info/connected');
  const unsubscribe = onValue(testRef, (snapshot) => {
    if (snapshot.val() === true) {
      console.log('✅ Firebase Realtime Database connected successfully');
    } else {
      console.log('❌ Firebase Realtime Database connection failed');
    }
  });

  // Test authentication state
  auth.onAuthStateChanged((user) => {
    if (user) {
      console.log('✅ Firebase Auth initialized with user:', user.uid);
    } else {
      console.log('ℹ️ Firebase Auth initialized - No user signed in');
    }
  });

  // Test environment variables
  console.log('Environment Variables Check:');
  console.log('Project ID:', import.meta.env.FIREBASE_PROJECT_ID ? '✅ Present' : '❌ Missing');
  console.log('Database URL:', import.meta.env.FIREBASE_DATABASE_URL ? '✅ Present' : '❌ Missing');
  
  // Return cleanup function
  return () => {
    unsubscribe();
  };
};

// Development-only auto-test
if (import.meta.env.DEV) {
  console.log('🔍 Running Firebase connection tests...');
  const cleanup = testFirebaseConnection();
  
  // Cleanup after 5 seconds
  setTimeout(() => {
    cleanup();
    console.log('🧹 Firebase test connections cleaned up');
  }, 5000);
} 